import React from "react";

const ThankYouSuccess = ({ selectedOffer, formData }) => {
  const rawName = formData?.fullName || formData?.name || formData?.contact_name || "";
  const userName = rawName.trim().split(" ")[0] || "there"; 
  
  const totalSaved = selectedOffer 
    ? selectedOffer.monthlySavings * selectedOffer.tenure 
    : 0;

  return (
    // Removed inline font styles & font-sans; relies purely on .plv17-app CSS
    <div className="flex flex-col min-h-[100dvh] w-full max-w-[400px] mx-auto bg-white antialiased text-[#111827] px-4 py-8">
      
      <h1 className="text-[26px] font-bold tracking-tight text-center mb-1 mt-2">
        Thank you, <span className="capitalize">{userName}</span>
      </h1>
      <p className="text-[14px] text-gray-800 text-center">
        Your <span className="font-bold">Home Loan</span> request has been received
      </p>

      <div className="text-center mt-6 mb-7">
        <p className="text-[13.5px] font-bold text-gray-900 mb-0.5 flex items-center justify-center gap-1.5">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
          Keep your phone handy.
        </p>
        <p className="text-[13px] text-gray-700 leading-snug px-6">
          Our lending partners will call you shortly to help you with your Home Loan.
        </p>
      </div>

      {/* Applied exact #12F280 to border, glow, and large amount text */}
      <div className="border-[2px] border-[#12F280] bg-[#fafffb] rounded-[16px] py-3.5 px-4 text-center mb-7 mx-auto w-[85%] max-w-[320px] shadow-[0_0_15px_rgba(18,242,128,0.35)]">
        <p className="text-[12px] font-semibold text-gray-600 mb-0.5 leading-snug">
          Estimated interest saved over<br/>your loan tenure
        </p>
        <p className="text-[28px] font-extrabold text-[#12F280] tracking-tight mb-0.5" style={{ textShadow: "0px 1px 2px rgba(0,0,0,0.1)" }}>
          ₹{totalSaved.toLocaleString('en-IN')}
        </p>
        <p className="text-[11px] font-medium text-gray-600">
          with {selectedOffer?.name || "the lender"} at {selectedOffer?.interestRate || "0"}% p.a.
        </p>
      </div>

      <div className="bg-[#fafafa] rounded-[16px] p-4 border border-gray-100 flex-1 mx-2 mb-4 shadow-sm">
        <h3 className="font-bold text-[14.5px] text-gray-900 mb-4">What happens next ?</h3>
        
        <div className="flex flex-col">
          <div className="flex gap-3">
            <div className="w-[16px] h-[16px] mt-0.5 rounded-full bg-black text-white flex items-center justify-center flex-none">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            </div>
            <div className="pb-3 border-b border-gray-200 mb-3 flex-1">
              <h4 className="text-[13px] font-bold text-gray-900 mb-0.5">Our Home Loan Expert Will Call You</h4>
              <p className="text-[12px] text-gray-500 leading-[1.35]">We'll discuss the selected offer and answer any questions you may have.</p>
            </div>
          </div>

          <div className="flex gap-3">
            <div className="w-[16px] h-[16px] mt-0.5 rounded-full bg-black text-white flex items-center justify-center flex-none">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            </div>
            <div className="pb-3 border-b border-gray-200 mb-3 flex-1">
              <h4 className="text-[13px] font-bold text-gray-900 mb-0.5">We'll Help You With The Documents</h4>
              <p className="text-[12px] text-gray-500 leading-[1.35]">Our team will guide you on the documents required for your Balance Transfer.</p>
            </div>
          </div>

          <div className="flex gap-3">
            <div className="w-[16px] h-[16px] mt-0.5 rounded-full bg-black text-white flex items-center justify-center flex-none">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            </div>
            <div className="pb-3 border-b border-gray-200 mb-3 flex-1">
              <h4 className="text-[13px] font-bold text-gray-900 mb-0.5">Lender Verification</h4>
              <p className="text-[12px] text-gray-500 leading-[1.35]">The lender will verify your application, documents and property details.</p>
            </div>
          </div>

          <div className="flex gap-3">
            <div className="w-[16px] h-[16px] mt-0.5 rounded-full bg-black text-white flex items-center justify-center flex-none">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            </div>
            <div className="flex-1">
              <h4 className="text-[13px] font-bold text-gray-900 mb-0.5">Your Balance Transfer Is Processed</h4>
              <p className="text-[12px] text-gray-500 leading-[1.35]">Once approved, the lender will complete the Balance Transfer process.</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ThankYouSuccess;